import "../i18n.mjs";
import { useCallback as e } from "react";
import { useTranslation as t } from "react-i18next";
//#region src/hooks/useTrCsatReason.ts
var n = () => {
	let { t: n } = t("csat");
	return e((e) => n(`reasons.${e}`, { defaultValue: e }), [n]);
};
//#endregion
export { n as useTrCsatReason };
